import { PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import { breakpoints, spacing } from '@cash-design-system/react'

const ModalPaneHeaderContainer = styled.div<{ justifyContent?: 'start' | 'end' }>`
  display: flex;
  justify-content: ${({ justifyContent }) => (justifyContent === 'start' ? 'space-between' : 'flex-end')};
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.arcadeColors.component.modalBackground};
  min-height: 5.5rem;
  padding: 0 ${spacing.l};

  ${breakpoints.tablet} {
    border-top: 1px solid ${({ theme }) => theme.arcadeColors.semantic.borderSubtle};
    border-bottom: 1px solid ${({ theme }) => theme.arcadeColors.semantic.borderSubtle};
    padding: 0 ${spacing.xl};
  }
`
export const ModalPaneHeader = ({
  children,
  justifyContent = 'start',
}: PropsWithChildren<{ justifyContent?: 'start' | 'end' }>) => {
  return <ModalPaneHeaderContainer justifyContent={justifyContent}>{children}</ModalPaneHeaderContainer>
}
